import { render, staticRenderFns } from "./SharedCard.vue?vue&type=template&id=72ee2f0e&scoped=true&"
import script from "./SharedCard.vue?vue&type=script&lang=js&"
export * from "./SharedCard.vue?vue&type=script&lang=js&"
import style0 from "./SharedCard.vue?vue&type=style&index=0&id=72ee2f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee2f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
